import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FontWeight } from '@y42/json-schema';

@Component({
  selector: 'y42-context-menu-font-weight',
  templateUrl: './context-menu-font-weight.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuFontWeightComponent {
  @Input()
  fontWeight?: FontWeight;

  @Output()
  fontWeightChanged = new EventEmitter<FontWeight>();

  protected readonly FontWeight = FontWeight;
}
